// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-section{margin-top:3rem;margin-bottom:3rem}@media(min-width:768px){.title-section h2{font-size:52px!important}}@media(min-width:1200px){.title-section .expand-container{padding-top:4rem}}@media(min-width:1400px){.title-section .expand-container{max-width:1420px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
